import axios from 'axios';
import { VM_DOMAIN } from './URLConstants';
import { attachAuthInterceptors } from './httpAuth';

// Create a basic Axios instance
const axiosInstance = axios.create({
    baseURL: VM_DOMAIN , //process.env.REACT_APP_API_BASE_URL || '', // You can configure a base URL in .env
    timeout: 10000, // 10 seconds timeout
    headers: {
      'Content-Type': 'application/json',
    },
  });

attachAuthInterceptors(axiosInstance);

  // Generic GET method
export async function getApi(endpoint, params = {}, headers = {}) {
    try {
      const response = await axiosInstance.get(endpoint, {
        params,
        headers,
      });
      return response.data?.data; // Always returning only the data part
    } catch (error) {
      console.error("GET API Error:", error);
      throw error; // Let the caller handle the error
    }
  }
  

// Generic POST method
export async function postApi(endpoint, data = {}, headers = {}) {
  try {
    const response = await axiosInstance.post(endpoint, data, {
      headers,
    });
    return response.data; // Always returning only the data part
  } catch (error) {
    console.error("POST API Error:", error);
    throw error; // Let the caller handle the error
  }
}



// Named default export to avoid anonymous default export lint error
const ApiService = {
  getApi,
  postApi,
};

export default ApiService;